import { Button, Spinner } from '@1trading/react';
import { Download } from 'lucide-react';
import { useAsyncFileExport } from '@/hooks/use-async-file-export';
import { buildClientCategorisationExportParameters, type ClientCategorisation } from '@/services/api/client-categorisation';

// Deliberate fix: the legacy spinner hung FOREVER when the WS push
// never arrived (a job that throws inside the SQS consumer gives no failure
// signal). After this grace period the spinner clears; the shared listener
// still downloads the file whenever the push eventually lands.
const EXPORT_SPINNER_TIMEOUT_MS = 2 * 60_000;

interface ClientCategorisationExportButtonProps {
  /** The export honors the ACTIVE filter — parameters mirror the current selection, {} when none */
  categorisation?: ClientCategorisation;
}

export const ClientCategorisationExportButton = ({ categorisation }: ClientCategorisationExportButtonProps) => {
  const { isExporting, requestExport } = useAsyncFileExport('futures-client-categorisation', buildClientCategorisationExportParameters(categorisation), {
    timeoutMs: EXPORT_SPINNER_TIMEOUT_MS,
  });

  return (
    // Disabled while in flight: legacy allowed double-clicks →
    // duplicate SQS jobs → duplicate downloads
    <Button className="gap-2" disabled={isExporting} onClick={requestExport} type="button">
      {isExporting ? <Spinner className="size-4" /> : <Download className="size-4" />}
      Download Data
    </Button>
  );
};
ClientCategorisationExportButton.displayName = 'ClientCategorisationExportButton';
